<template>
  <div>
    <!-- <button @click="showPlot">Show Plot</button> -->
    <b-button v-b-modal.modalPopover @click="showPlot">Show plot</b-button>

    <!-- BootstrapVue modal -->
    <b-modal v-model="showModal" title="Histogram" @shown="handleModal" @hidden="clearPlot" class="custom-modal" size="xl" ok-only>
      <div class="modal-content">
      <Plotly v-if="showPlotComponent" :data="data" :layout="layout" :config="plotConfig"></Plotly></div>
    </b-modal>
  </div>
</template>

<script>
import { Plotly } from 'vue-plotly';
import { BModal } from 'bootstrap-vue';


export default {
  components: {
    Plotly,
    BModal,
  },
  data() {
    return {
      showPlotComponent: false,
      showModal: false,
      data: [{
        x: [1, 2, 3, 4],
        type: 'histogram',
      }],
      layout: {
       // Adjust the width as needed
        autosize: true,
        margin: { l: 50, r: 50, b: 50, t: 50, pad: 4 },
      },
      plotConfig: {
        displayModeBar: false,
        responsive: true
      },
    };
  },

  mounted() {
    this.showModal()
  },

  methods: {
    showPlot() {
      // Set showPlotComponent to true to render the Plotly component
      this.showPlotComponent = true;
      // Set showModal to true to show the BootstrapVue modal
      this.showModal = true;
      // 
      
      
      console.log(this.data[0].x)
    },
    clearPlot() {
      // Reset showPlotComponent when the modal is hidden
      this.showPlotComponent = false;
    },

    handleModalShown() {
      // This method is called when the modal is shown
      // Use Plotly.relayout to update the plot layout
      Plotly.relayout('myDiv', this.layout);
    },
  },
};
</script>

<style scoped>
/* Custom styling for the modal */
.custom-modal {
  /* Example styles, modify as needed */
  background-color: #f0f0f0;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  margin: 0 auto;
}

/* Custom styling for modal content container */
.modal-content{
  display: flex;
  align-items: center;      /* Center vertically */
  justify-content: center;  /* Center horizontally */
  height: 100%;             /* Full height of the container */
  width: 100%
}

/* Custom styling for modal title */
.custom-modal {
  color: #333;
}

/* Custom styling for modal body */
.custom-modal {
  padding: 20px;
}

</style>